import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  aspect-ratio: 1/1;
  width: 35rem;
  height: auto;
`;

const Arrow = styled.path`
  animation-name: move;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-out;

  @keyframes move {
    0% { transform: translateY(0rem) }
    75% { transform: translateY(10rem) }
    100% { transform: translateY(10rem) }
  }
`;

const Scroll = ({ color = "black" }: { color?: string }) => (
  <Wrapper
    height={512} width={512}
    viewBox="0 0 50 50"
  >
    <g>
      <path fill={color} d="m25 45a14 14 0 0 0 14-14v-12a14 14 0 0 0 -28 0v12a14 14 0 0 0 14 14zm-12-26a12 12 0 0 1 24 0v12a12 12 0 0 1 -24 0z" />
      <Arrow fill={color} d="m24 24.5h.09l.2.21a1 1 0 0 0 1.42 0l.2-.21h.09v-.09l5.71-5.7-1.42-1.42-4.29 4.3v-10.59h-2v10.59l-4.29-4.3-1.42 1.42 5.71 5.7z" />
    </g>
  </Wrapper>
);

export default Scroll;